export const SET_CONFIGURACOES = "ASSINATURAS/SET_CONFIGURACOES";
export const SET_ISLOADING = "ASSINATURAS/SET_ISLOADING";
